import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-hazards-account-hierarchy-of-controls',
  templateUrl: './hazards-account-hierarchy-of-controls.component.html',
  styleUrls: ['./hazards-account-hierarchy-of-controls.component.scss']
})
export class HazardsAccountHierarchyOfControlsComponent implements OnInit {

  constructor(public app: AppService) { }

  ngOnInit() {
  }

}
